export default __webpack_public_path__ + "static/media/avadefault.2dff289e.svg";